<template>
  <div>
    <v-container class="app-breadcrumbs-container">
      <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <template slot="item" slot-scope="props">
          <router-link
            :to="props.item.to"
            :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
          >
            {{ props.item.text }}
          </router-link>
        </template>
      </v-breadcrumbs>
    </v-container>
    <div v-if="pageLoading" class="page-loading-container">
      <v-progress-circular
        :size="60"
        :width="5"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div class="wrapper" v-show="!pageLoading">
      <v-container class="delivery-container" v-if="from != 'garnish'">
        <v-layout class="delivery-summary">
          <v-flex xs6 class="cover-container" ref="cover">
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide
                :src="item ? item.url : ''"
                :key="index"
                v-show="delivery.images && delivery.images.length > 1"
                v-for="(item, index) in delivery.images"
              >
                <img :src="item ? item.url : ''" class="cover" />
              </swiper-slide>
              <img
                :src="
                  delivery.images
                    ? delivery.images[0]
                      ? delivery.images[0].url
                      : ''
                    : ''
                "
                class="cover"
                v-show="delivery.images && delivery.images.length == 1"
              />
              <div
                class="swiper-pagination swiper-pagination-white"
                slot="pagination"
                v-show="delivery.images && delivery.images.length > 1"
              ></div>
            </swiper>
          </v-flex>
          <v-flex xs6 class="summary-container">
            <h1 class="delivery-name">
              {{ delivery.name }}
              <div class="allergen-container">
                <img
                  v-for="(allergen, index) in delivery.allergen"
                  :src="allergen.image"
                  :key="index"
                  class="allergen-img"
                />
              </div>
            </h1>
            <div class="delivery-price">
              €{{ delivery.takeawayPrice | fixed(2, true) }}
            </div>
            <div class="summary">
              {{ delivery.description }}
            </div>

            <!-- begin 备注 属性选择 -->
            <div
              class="attributes-container"
              v-if="
                delivery.attributes_cate && delivery.attributes_cate.length != 0
              "
            >
              <div class="attributes-title">
                <div>{{ $t("delivery_detail.remark") }}：</div>
                <!-- <input placeholder="输入或选择备注" /> -->
              </div>
              <div
                v-for="(cate, cateIndex) in delivery.attributes_cate || []"
                :key="cate.guid"
              >
                <div class="title">
                  {{ cate.attr_cate_name }}（{{
                    $t(cate.type === 0 ? "unClass.add389" : "unClass.add392", {
                      num: cate.min_limit
                    })
                  }}）
                </div>
                <div class="attributes-content">
                  <div
                    v-for="(item, index) in cate.attributes || []"
                    :key="index"
                    :class="{ item: true, active: item.check }"
                    @click="checkAttr(item, cateIndex, index)"
                  >
                    {{ item.name
                    }}{{ Number(item.price) ? ` €${item.price}` : `` }}
                  </div>
                </div>
              </div>
            </div>
            <!-- begin 备注 属性选择 -->
            <div
              class="form-group"
              v-if="
                delivery.garnish &&
                  delivery.garnish.length == 0 &&
                  storeInfo.takeawayStatus != 0
              "
            >
              <v-layout align-start>
                <v-layout>
                  <i
                    class="iconfont icon-yichu stepper"
                    @click="handleMinusNum(delivery.guid)"
                  ></i>
                  <v-flex xs2>
                    <div class="goods-num" :key="getGoodsNums(delivery.guid)">
                      {{ getGoodsNums(delivery.guid) }}
                    </div>
                  </v-flex>
                  <i
                    class="icon iconfont icon-plus stepper"
                    @click="handleAddToCart"
                  ></i>
                </v-layout>
              </v-layout>
              <v-layout align-start style="margin-top: 20px">
                <v-flex xs10>
                  <button
                    class="button shadow add-cart-button"
                    @click="backPage"
                  >
                    {{ $t("unClass.add402") }}
                  </button>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- begin 选择套餐-->
      <v-container
        class="garnish-container"
        v-if="delivery.garnish && delivery.garnish.length"
      >
        <div class="garnish-title">{{ $t("garnish.title") }}</div>
        <div
          class="garnish-item"
          :key="index"
          v-for="(item, index) in delivery.garnish"
        >
          <div class="garnish-name">{{ item.name }}</div>
          <div class="garnish-num">
            <div>
              {{
                item.min_select_type == 0
                  ? $t("garnish.num_tip", { num: item.min_select_num })
                  : $t("garnish.required", { num: item.min_select_num })
              }}
            </div>

            <div class="must" v-if="item.min_select_num != 0">
              {{ $t("garnish.must") }}
            </div>
          </div>
          <div
            class="commodity-item"
            :key="com_index"
            v-for="(com_item, com_index) in item.commodity"
          >
            <div class="cover_logo_box">
              <img
                class="cover_logo"
                :src="list ? list.url : ''"
                alt=""
                v-for="(list, index) in com_item.images"
                :key="index"
                v-show="
                  com_item.images &&
                    com_item.images.length < 2 &&
                    com_item.images.length > 0
                "
                @mouseover="mouseoverBtn(list ? list.url : '')"
                @mouseleave="imgShow = false"
              />
              <div
                class="big_img"
                v-if="
                  com_item.images &&
                    com_item.images.length < 2 &&
                    com_item.images.length > 0
                "
              >
                <img
                  :src="imgShowUrl"
                  alt=""
                  v-show="
                    imgShow &&
                      imgShowUrl == com_item.images &&
                      com_item.images[[0]].url
                  "
                />
              </div>
            </div>

            <div class="midlle_box" style="display:inline-block">
              <span class="text_name">{{ com_item.commodity_name }}</span>
              <img
                class="allergen_img"
                :src="list.image"
                v-for="(list, index) in com_item.allergens"
                :key="index"
                alt=""
                v-show="list.image != null"
              />

              <div class="text_box">
                <span>{{ com_item.Description }}</span>
              </div>
            </div>

            <div class="new_price">
              {{ com_item.price }}€
              <div
                class="checkbox_btn shadow add-cart-button disabled-btn"
                @click="
                  selectGarnish(
                    delivery.garnish[index].commodity[com_index],
                    item,
                    index,
                    com_index
                  )
                "
                :class="{
                  checkbox_btn_active:
                    delivery.garnish[index].commodity[com_index].checked
                }"
              >
                <span
                  v-show="
                    delivery.garnish[index].commodity[com_index].checked != true
                  "
                  >Seleccionar</span
                >
                <span
                  v-show="
                    delivery.garnish[index].commodity[com_index].checked == true
                  "
                  >Seleccionado</span
                >
                <v-checkbox
                  class="index checkbox_box"
                  :label="
                    delivery.garnish[index].commodity[com_index]
                      .commodity_name +
                      delivery.garnish[index].commodity[com_index].id
                  "
                  v-model="delivery.garnish[index].commodity[com_index].checked"
                  @change="changeGarnish"
                  :disabled="
                    getDisabled(
                      delivery.garnish[index].commodity[com_index],
                      item
                    )
                  "
                />
                <!--                                :disabled="!delivery.garnish[index].commodity[com_index].checked && item.chexked_num >= item.min_select_num"-->
              </div>
            </div>
          </div>
        </div>

        <div class="button-container">
          <div class="price">Total {{ total_price }} €</div>
          <button
            class="button shadow add-cart-button"
            @click="handleGarnishChecked"
            v-if="canSubmit"
          >
            {{ $t("delivery_detail.addToCart") }}
          </button>
          <button
            class="button shadow add-cart-button disabled-btn"
            v-if="!canSubmit"
          >
            {{ $t("delivery_detail.addToCart") }}
          </button>
        </div>
      </v-container>
      <!-- end 选择套餐-->
    </div>

    <v-dialog v-model="passwordTip" max-width="500px">
      <v-card>
        <v-card-title>
          <span>{{ tip }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="primary" flat @click="passwordTip = false">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, integer, minValue } from "vuelidate/lib/validators";
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import { fixed } from "../../utils";

export default {
  mixins: [validationMixin],
  validations: {
    num: { required, integer, minValue: minValue(1) }
  },
  data() {
    return {
      added: false,
      pageLoading: false,

      passwordTip: false,
      tip: "",

      total_price: 0,

      from: "",
      imgShow: false,
      canSubmit: false,

      height: 0,
      swiperOptions: {
        loop: true,
        speed: 300,
        autoHeight: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      imgShowUrl: ""
    };
  },
  mounted() {
    this.initData(this.$route.params.id);
    this.$nextTick(() => {
      setTimeout(() => {
        this.height = this.$refs.cover.clientWidth;
      }, 1000);
    });

    console.log("delivery", this.delivery);
    // this.delivery.garnish.map((item, index) => {
    //   item.commodity.map(com_item => {
    //     com_item.checked = false
    //   });
    // });
    console.log("添加", this.delivery);
  },

  computed: {
    ...mapGetters({
      delivery: "currentDelivery"
    }),
    ...mapState(["carts", "storeInfo"]),
    ...mapGetters(["cart"]),
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("breadcrumbs.home")
        },
        {
          disabled: false,
          text: this.$t("breadcrumbs.delivery_list"),
          to: { name: "home" }
        },
        {
          disabled: true,
          text: this.delivery.name,
          to: "home"
        }
      ];
    },
    getGoodsNums() {
      return guid => {
        let num = 0;
        (this.carts || []).map(item => {
          if (item.guid === guid) num += item.num;
        });
        return num;
      };
    },
    existLastIndex() {
      return this.cart.items.findLastIndex(
        item => item.guid === this.delivery.guid
      );
    }
  },

  watch: {},

  methods: {
    ...mapMutations(["addToCart", "setDelivery", "resetCart", "minusFromCart"]),
    ...mapActions(["getDeliveryDetail"]),
    getDisabled(commodity, item) {
      if (commodity.checked) return false;
      if (item.min_select_type === 0) {
        return false;
      } else if (item.min_select_type === 1) {
        return item.chexked_num >= item.min_select_num;
      }
      return false;
    },
    handleAddToCart() {
      let cart_attributes = [];

      if (
        this.delivery.attributes_cate &&
        this.delivery.attributes_cate.length
      ) {
        let flag = true;
        this.delivery.attributes_cate.forEach(cate => {
          if (cate.attributes) {
            cate.attributes.forEach(attr => {
              if (attr.check) {
                cart_attributes.push(attr.guid);
              }
            });
          }
        });
        this.delivery.attributes_cate.forEach(item => {
          if (
            !this.$allowAddAttr(
              this.delivery.attributes_cate,
              cart_attributes,
              null,
              item
            )
          )
            flag = false;
        });
        if (!flag) return;
      }

      this.addToCart({
        num: 1,
        guid: this.delivery.guid,
        attributes: cart_attributes,
        price: this.delivery.takeawayPrice
      });
    },

    backPage() {
      this.$router.back();
    },

    handleMinusNum(guid) {
      this.minusFromCart({
        num: 1,
        guid,
        index: this.existLastIndex === -1 ? undefined : this.existLastIndex
      });
    },

    async initData(id) {
      this.pageLoading = true;
      const guid = id;
      await this.getDeliveryDetail({ guid });
      this.pageLoading = false;
      this.from = this.$route.query.from;
      this.total_price = this.delivery.takeawayPrice;
    },

    selectGarnish(commodity, item, garnishIndex, comIndex) {
      if (item.min_select_type === 1) {
        if (
          item.min_select_num === 1 &&
          item.chexked_num >= item.min_select_num
        ) {
          let _comIndex = this.delivery.garnish[
            garnishIndex
          ].commodity.findIndex(it => it.checked);
          if (_comIndex !== -1)
            this.delivery.garnish[garnishIndex].commodity[
              _comIndex
            ].checked = false;
          this.delivery.garnish[garnishIndex].commodity[
            comIndex
          ].checked = true;
          this.$forceUpdate();
        }
      }
    },

    changeGarnish() {
      this.total_price = 0;
      this.canSubmit = true;
      this.delivery.garnish.map((item, index) => {
        this.delivery.garnish[index].chexked_num = 0;
        item.commodity.map(com_item => {
          if (com_item.checked) {
            this.delivery.garnish[index].chexked_num += 1;
            this.total_price += parseFloat(com_item.price);
          }
        });
        if (item.min_select_type === 0) {
          if (this.delivery.garnish[index].chexked_num < item.min_select_num) {
            this.canSubmit = false;
          }
        } else if (item.min_select_type === 1) {
          if (
            this.delivery.garnish[index].chexked_num !== item.min_select_num
          ) {
            this.canSubmit = false;
          }
        }
      });

      this.total_price += parseFloat(this.delivery.takeawayPrice);
    },

    /**
     * 选择属性标签
     */
    checkAttr(item, cateIndex, index) {
      let attributes = this.delivery.attributes_cate;

      let carts = this.carts,
        selected = [];
      this.delivery.attributes_cate.forEach(cate => {
        if (cate.attributes) {
          cate.attributes.forEach(attr => {
            if (attr.check) {
              selected.push(attr.guid);
            }
          });
        }
      });
      if (!this.delivery.attributes_cate[cateIndex].attributes[index].check) {
        if (!this.$allowAddAttr(attributes, selected, item.guid)) return;
      }

      this.delivery.attributes_cate[cateIndex].attributes[index].check = !this
        .delivery.attributes_cate[cateIndex].attributes[index].check;

      let cart_attributes = [];
      this.delivery.attributes_cate.forEach(cate => {
        if (cate.attributes) {
          cate.attributes.forEach(attr => {
            if (attr.check) {
              cart_attributes.push(attr.guid);
            }
          });
        }
      });

      carts.map((item1, index) => {
        if (item1.guid == this.delivery.guid) {
          carts[index].attributes = cart_attributes;
        }
      });

      this.resetCart(carts);

      this.setDelivery({
        ...this.delivery,
        attributes
      });
    },

    handleGarnishChecked() {
      debugger;
      let chencked_garnish = [];
      let chencked_garnish_items = [];
      let total_price = 0;

      this.delivery.garnish.map((item, index) => {
        this.delivery.garnish[index].chexked_num = 0;

        item.commodity.map(com_item => {
          if (com_item.checked) {
            this.delivery.garnish[index].chexked_num += 1;
            chencked_garnish.push(com_item.commodity_guid);
            chencked_garnish_items.push(com_item);
            total_price += parseFloat(com_item.price);
          }
        });
      });

      total_price += parseFloat(this.delivery.takeawayPrice);
      this.addToCart({
        num: 1,
        guid: this.delivery.guid,
        garnish: chencked_garnish,
        garnish_items: chencked_garnish_items,
        price: this.delivery.takeawayPrice,
        total_price
      });

      this.$router.push({ name: "home" });
    },
    mouseoverBtn(adta) {
      this.imgShowUrl = adta;
      this.imgShow = true;
      console.log("adta", adta);
    }
  },
  filters: {
    fixed
  }
};
</script>

<style scoped lang="sass" src="./delivery-detail.sass"></style>
<style scoped lang="sass">
.cover_logo_box
    float: left
    width: 50px
    height: 50px
    margin-right: 12px

.cover_logo
    width: 50px
    height: 50px
    object-fit: cover

.midlle_box
    float: left
    width: 80%

.text_box
    clear: both
    color: #676767
    font-size: 12px
    white-space: pre-line

.text_box span
    float: left

.checkbox_box
    position: absolute
    width: 100%
    height: 100%
    float: left
    margin-top: 0
    margin-left: 0
    padding: 0
    left: 0
    top: 0
    opacity: 0
    background-color: red


.v-input--selection-controls__input
    width: 150px
    height: 40px


.allergen_img
    /*float: left*/
    width: 30px
    height: 30px
    object-fit: cover
    margin-left: 6px

.text_name
    font-size: 18px
    float: left

.checkbox_btn
    width: 150px
    height: 40px

    /deep/ .v-input--selection-controls__input
        display: none

    /deep/ .v-label
        position: absolute
        width: 150px
        height: 40px
        top: 0
        left: 0 !important

.checkbox_btn_active
    color: #ffffff
    background: var(--themeColor)

.new_price
    text-align: center

.big_img
    position: relative
    z-index: 100
    left: 60px
    top: -60px

.big_img img
    width: 400px
    height: 400px
    object-fit: cover

.summary-container
    .summary
        white-space: pre-line
</style>
